<template>
  <div
    :class="[
      'label',
      backgroundColorClass,
      {
        'label--small': isSmall,
        'label--absolute': isAbsolute,
        'label--blue': hasBlueBackground,
        'label--border': hasNavyBorder,
      },
    ]"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  backgroundColor?: string
  hasBlueBackground?: boolean
  hasNavyBorder?: boolean
  isSmall?: boolean
  isAbsolute?: boolean
}
const props = defineProps<Props>()

const backgroundColorClass = computed(() => {
  return `bg-${props.backgroundColor}`
})
</script>

<style lang="scss" scoped>
.label {
  border-radius: 9px;
  padding: 4px 12px;
  z-index: 10;
  position: static;

  &--absolute {
    position: absolute;
    top: 34px;
    right: 34px;

    @media (min-width: $breakpoint-lg) {
      top: 44px;
      right: 44px;
    }
  }

  &__text {
    margin-bottom: 0;
    line-height: 16px;
  }

  &--blue {
    background-color: var(--blue-600);

    :deep(.label__text) {
      color: var(--white);
    }
  }

  &--border {
    background-color: transparent;
    border: 1px solid var(--navy-600);
    padding: 3px 11px;

    :deep(.label__text) {
      color: var(--cobalt-800);
    }
  }

  &--small {
    border-radius: var(--border-radius-base);
    padding: 2px 8px;

    :deep(.label__text) {
      font-size: 10px;
    }

    &.label--border {
      padding: 1px 7px;
    }
  }
}
</style>
